import { SuccessRO } from '@routellers/types/dist/shared/success.ro';

import { ApiMethodDeclaration } from '..';

/** ID city */
type ParamsData = number;

type ResponseData = SuccessRO;

export const removeNamespace: ApiMethodDeclaration<ParamsData, ResponseData> = (id) => ({
    url: `/translations/namespaces/${id}`,
    method: 'DELETE',
});
